export default __webpack_public_path__ + "static/media/countbanner.3ae4af2e.png";